<div class='modals'>
  <div class="details-modal">
    <div class='details-modal-title type'>
      <div class='row'>
        <div class='col-10'>
          <h1>{{type}}</h1>
        </div>
        <div class='details-modal-close col-2' (click)='close()'>
          <i class="fas fa-times"></i>
        </div>
      </div>
    </div>
    <div class="details-modal-title title-notif">
      <h1 class='text-uppercase font-weight-bold'>{{title}}</h1>
    </div>
    <div class="details-modal-content">
      <!-- {{ 'petitionId: ' + petitionId }}
      {{ 'docName: ' + petitionId }}
      {{ 'userId: ' + petitionId }} -->
      <p [innerHTML]="message"></p>
    </div>
    <div class="details-modal-content modal-footer">
      <b>{{date | date:'dd/MM/yyyy hh:mm a' }}</b>
      <button *ngIf="(petitionId && docName) || (petitionId && userId)" type="button" class="btn btn-primary font-weight-bold m-2 w-100" (click)="close(); viewDocument()">
        <i *ngIf="docName" class="fas fa-eye"></i>
        {{ docName ? 'Ver documento': 'Continuar proceso'}}
        <i *ngIf="!docName" class="fa fa-arrow-right ml-1"></i>
      </button>
    </div>
  </div>
</div>
